/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Info_LocationInputs */



/**
* | output |
* | --- |
* | "Location" |
*
* @param {Tournament_Info_LocationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_info_location = /** @type {((inputs?: Tournament_Info_LocationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Info_LocationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lieu")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ubicación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Localização")
	if (locale === "it") return /** @type {LocalizedString} */ ("Località")
	return /** @type {LocalizedString} */ ("Location")
});